import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../Translator';
import Stack from '../Stack';
import Button from '../Button';
import Icon from '../Icon';
import { TextStyle } from '../TextStyle';
import { CodeEditor } from '../CodeEditor';
import styles from './CodeSnippet.module.css';

const bindClasses = classNameBind.bind(styles);

const CodeSnippet = ({
  code,
  onCopy,
  error,
  t,
  dataId,
  fixedHeight,
  fullHeight,
  mode,
}) => (
  <Stack vertical dataId={dataId} spacing="narrow">
    {error ? (
      <div className={bindClasses('error-container')}>
        <div className={bindClasses('sidebar')}>
          <div>1</div>
          <div>2</div>
          <div>3</div>
          <div>4</div>
          <div>5</div>
          <div>6</div>
        </div>
        <div className={bindClasses('flex-content')}>
          <div className={bindClasses('flex-items')}>
            <Icon name="exclamation-mark-circle" color="red" size="medium" />
            <div className={bindClasses('text-wrapper')}>
              <TextStyle type="negative">
                {t('codeSnippet.error.message')}
              </TextStyle>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <CodeEditor
        name="codeSnippet"
        readOnly
        value={code}
        fullWidth
        fixedHeight={fixedHeight}
        fullHeight={fullHeight}
        mode={mode}
      />
    )}
    <CopyToClipboard text={code} onCopy={onCopy}>
      <Button
        appearance="simple"
        onClick={() => {}}
        text={t('copyText')}
        icon="clipboard"
        disabled={error}
      />
    </CopyToClipboard>
  </Stack>
);

CodeSnippet.defaultProps = {
  code: '',
  onCopy: () => {},
  error: false,
  dataId: 'CodeSnippet',
  fixedHeight: false,
  fullHeight: false,
  mode: 'html',
};

const TranslatedCodeSnippet = withTranslation('components')(CodeSnippet);
TranslatedCodeSnippet.displayName = 'CodeSnippet';

export {
  CodeSnippet,
  TranslatedCodeSnippet,
};
